module.exports = __webpack_public_path__ + "img/other_earth.85542848.png";